import React, {useEffect, useState} from "react";
import {FlatList, FlatListProps} from "react-native";
import {useResponsive} from "../hooks";

export interface ReactiveFlatListPropsInterface<ItemT> extends FlatListProps<ItemT> {
    itemMinimumWidth: number;
    itemMargin?: number;
}

export type ReactiveFlatListProps<T = any> = ReactiveFlatListPropsInterface<T>;

export const ReactiveFlatList = ({ numColumns, ...props}: ReactiveFlatListProps) => {
    const {screenWidth, deviceType} = useResponsive();

    const calculateColumnCount = () => {
        return 3 - deviceType;
    };

    const [columnCount, setColumnCount] = useState(calculateColumnCount());

    useEffect(() => {
        const calculatedColumnCount = calculateColumnCount();

        const result = numColumns && numColumns < calculatedColumnCount ? numColumns : calculatedColumnCount;

        setColumnCount(result);
    }, [screenWidth, deviceType]);

    return (
        <FlatList
            key={columnCount}
            numColumns={columnCount}
            {...props}
        />
    );
};
